export default __webpack_public_path__ + "d8bf522.mp4";